import React from 'react';
import { Modal, Divider, Button, Image, Message } from 'semantic-ui-react';
import bulkOperation from '../../../images/common/bulk-operation.png'
import refImg from '../../../images/svg/noti-content.svg';
import Labels from '../../common/Labels';

const ConfirmImportModal = ({ contentConfirmImport, closeConfirmModal, content, submitModal, assignCategoriesModal }) => {
    const submitInfoModal = () => {
        submitModal();
    }
    const assignCategories = () =>{
        assignCategoriesModal();
    }
    return <Modal
        animated
        open={contentConfirmImport}
        onClose={closeConfirmModal}
        size='small'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
    >
        <Modal.Header>Import Content</Modal.Header>
        <Divider style={{ margin: "10px 0 0px" }} />
        <Modal.Content scrolling>
                <Message icon >
                    <Image src={refImg} height="12px" style={{ margin: "0 5px 0 0" }} />
                    <Message.Content> You are importing {content.contentCount} content in your workspace</Message.Content>
                </Message>
                {/* <strong>You are importing {content.contentCount} contents in your workspace</strong><br /> */}
                <strong>Auto assign knowledge bank or assign Knowledge bank from your Workspace to all these content</strong>
                <div style={{
                    float: "left",
                    display: "inline-block",
                    padding: "0 20px 0 0"
                }}>
                    <Labels
                        name="Note"
                        text={<Image src={bulkOperation} height="100px" />
                        }
                    />
                </div>
                <div className="fs_italic" style={{ margin: "52px 0 0 0" }} >
                    All the imported content will be placed under your Indesign content section.<br />You can change the Knowledge bank/Category/Sub-Category of single or multiple content by navigating to Content Manager and then using bulk operation &gt; Change category.
                </div>
        </Modal.Content>

        <Modal.Actions className="actionInFormcy">
            <Button
                className="button-submit float-right"
                id='importPlaybook'
                onClick={assignCategories}
            > Assign </Button>
            <Button
                className="button-submit float-right"
                id='importPlaybook'
                onClick={submitInfoModal}
            > Import Now </Button>
            <Button
                id='copyCancel'
                className="button-cancel"
                onClick={closeConfirmModal}
            > Cancel </Button>
        </Modal.Actions>
    </Modal >
    
}
export default ConfirmImportModal;